import React from 'react';

import type { IntegrationEnrichmentComponent } from '../../../../../core/data-sources/content-components/types.js';

const Integration: React.FC<IntegrationEnrichmentComponent> = ({ embed }) => {
  return (
    <div
      className="integration-enrichment"
      dangerouslySetInnerHTML={{
        __html: embed?.html || '',
      }}
    />
  );
};

export default Integration;
